import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminComments = () => {
  const [comments, setComments] = useState([]);

  const load = async () => {
    const res = await api.get("/comments");
    setComments(res.data);
  };

  const moderate = async (id, status) => {
    try {
      await api.put(`/comments/${id}/moderate`, { status });
      toast.success("Comment updated");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete comment?")) return;

    try {
      await api.delete(`/comments/${id}`);
      toast.success("Comment deleted");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">
        Comments
      </h1>

      <div className="space-y-4">
        {comments.map((comment) => (
          <div key={comment.id} className="bg-white rounded-3xl border p-6">
            <div className="flex justify-between gap-4 mb-3">
              <div>
                <h3 className="font-black">{comment.name}</h3>
                <p className="text-sm text-slate-500">{comment.email}</p>
              </div>

              <span className="text-xs font-bold px-3 py-1 rounded-full bg-slate-100 h-fit">
                {comment.status}
              </span>
            </div>

            <p className="text-slate-700 mb-4">{comment.body}</p>

            <div className="flex flex-wrap gap-2">
              {["approved", "pending", "unapproved", "spam", "trash"].map((s) => (
                <button
                  key={s}
                  onClick={() => moderate(comment.id, s)}
                  className="px-4 py-2 rounded-xl bg-slate-100 hover:bg-[#0b6b1d] hover:text-white text-sm font-bold"
                >
                  {s}
                </button>
              ))}

              <button
                onClick={() => remove(comment.id)}
                className="px-4 py-2 rounded-xl bg-red-50 text-red-600 text-sm font-bold"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdminComments;